<template>
  <foreignObject :x="x" :y="y" :width="width" height="14">
    <v-skeleton-loader v-if="loading" type="image" :width="width" height="14" />
    <v-text-field
      v-else
      :type="disable ? 'text' : 'number'"
      :value="disable ? 'CALC' : paramData.value"
      :suffix="unit"
      :disabled="disable"
      :readonly="readonly"
      class="hmi-input"
      :class="{
        'disable-input': disable,
        'error-input': hasError,
        'sm-input': size === 'sm',
        'md-input': size === 'md',
        'lg-input': size === 'lg',
      }"
      @input="onChange"
      flat
      solo
      dense
    />
  </foreignObject>
</template>

<script>
import {
  UPDATE_HMI_PARAM_ERROR,
  UPDATE_HMI_PARAM_VALUE,
} from "@/core/services/store/modules/hmi/hmi.module";
import { mapGetters } from "vuex";

export default {
  name: "HMIInput",

  props: {
    x: { type: String, required: true },
    y: { type: String, required: true },
    HMIKey: { type: String, required: true },
    size: { type: String, default: "lg" },
    unit: { type: String, default: "°C" },
    checkEnable: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },

  computed: {
    ...mapGetters(["HMIParams"]),
    paramData() {
      return this.HMIParams[this.HMIKey];
    },
    disable() {
      if (this.checkEnable) {
        return !this.paramData.enable;
      }
      return false;
    },
    hasError() {
      return this.paramData.error;
    },
    width() {
      switch (this.size) {
        case "sm":
          return "40";
        case "md":
          return "48";
        case "lg":
          return "70";
        default:
          return "70";
      }
    },
  },

  methods: {
    onChange(value) {
      this.$store.commit(UPDATE_HMI_PARAM_VALUE, {
        key: this.HMIKey,
        value: Number(value),
      });

      const error =
        this.paramData.value > this.paramData.max ||
        this.paramData.value < this.paramData.min;

      this.$store.commit(UPDATE_HMI_PARAM_ERROR, {
        key: this.HMIKey,
        error,
      });
    },
  },
};
</script>

<style lang="scss">
.hmi-input {
  border: 1px solid var(--v-lightGrey-base);
  direction: ltr !important;
  & .v-input__control {
    min-height: 14px !important;
    max-height: 14px !important;
  }
  & .v-text-field__details {
    display: none;
  }
  & .v-input__slot {
    background-color: var(--v-background-base) !important;
    padding: 0 2px !important;
    margin: 0 !important;
    min-height: 14px !important;
    max-height: 14px !important;
    border-radius: 2px !important;
  }
  & .v-text-field__suffix {
    font-size: 8px !important;
    color: var(--v-infoGreen-base);
  }
  & input {
    height: 14px;
    max-height: 14px !important;
    font-size: 9px;
    direction: ltr;
  }
}
.disable-input {
  & .v-input__slot {
    background-color: rgba(29, 57, 141, 0.7) !important;
  }
  & .v-text-field__suffix {
    color: var(--v-lightGrey-base) !important;
  }
  & input {
    color: white !important;
  }
}
.error-input {
  border-color: var(--v-error-base) !important;
  & .v-input__slot {
    background-color: rgba(217, 36, 43, 0.2) !important;
  }
}
.sm-input {
  width: 40px;
}
.md-input {
  width: 48px;
}
.lg-input {
  width: 70px;
}
</style>
